import _classCallCheck from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/createClass.js";
import getIdentifierNames from "./util/getIdentifierNames";

var NameManager = /*#__PURE__*/function () {
  function NameManager(code, tokens) {
    _classCallCheck(this, NameManager);

    ;

    NameManager.prototype.__init.call(this);

    this.usedNames = new Set(getIdentifierNames(code, tokens));
  }

  _createClass(NameManager, [{
    key: "__init",
    value: function __init() {
      this.usedNames = new Set();
    }
  }, {
    key: "claimFreeName",
    value: function claimFreeName(name) {
      var newName = this.findFreeName(name);
      this.usedNames.add(newName);
      return newName;
    }
  }, {
    key: "findFreeName",
    value: function findFreeName(name) {
      if (!this.usedNames.has(name)) {
        return name;
      }

      var suffixNum = 2;

      while (this.usedNames.has(name + String(suffixNum))) {
        suffixNum++;
      }

      return name + String(suffixNum);
    }
  }]);

  return NameManager;
}();

export { NameManager as default };